import { Award, Target, AlertTriangle, MessageSquare } from "lucide-react";

export const feedbackConfig = {
  positive: {
    icon: Award,
    color: "bg-green-100 text-green-700 border-green-200",
    badgeColor: "bg-green-100 text-green-800",
    label: "Positive Feedback",
  },
  development: {
    icon: Target,
    color: "bg-orange-100 text-orange-700 border-orange-200",
    badgeColor: "bg-orange-100 text-orange-800",
    label: "Area for Development",
  },
  escalation: {
    icon: AlertTriangle,
    color: "bg-red-100 text-red-700 border-red-200",
    badgeColor: "bg-red-100 text-red-800",
    label: "Escalation/Incident",
  },
  general: {
    icon: MessageSquare,
    color: "bg-blue-100 text-blue-700 border-blue-200",
    badgeColor: "bg-blue-100 text-blue-800",
    label: "General Update/Observation",
  },
};

export const mapTypeToConfigKey = (type: string) => {
  switch (type?.toLowerCase()) {
    case "positive_feedback":
      return "positive";
    case "area_for_development":
      return "development";
    case "escalation_incident":
      return "escalation";
    case "general_update":
      return "general";
    default:
      return "general";
  }
};

export const mapApiTypeToFormType = (apiType: string): string => {
  switch (apiType) {
    case "Positive_Feedback":
      return "positive";
    case "Area_for_Development":
      return "development";
    case "Escalation_Incident":
      return "incident";
    case "General_Update_Observation":
    default:
      return "general";
  }
};

export const mapFormTypeToApiType = (formType: string): string => {
  switch (formType) {
    case "positive":
      return "Positive_Feedback";
    case "development":
      return "Area_for_Development";
    case "incident":
      return "Escalation_Incident";
    case "general":
    default:
      return "General_Update_Observation";
  }
};

export const noteTypes = [
  { value: "positive", label: "Positive Feedback" },
  { value: "development", label: "Area for Development" },
  { value: "incident", label: "Escalation/Incident" },
  { value: "general", label: "General Update/Observation" },
];
